import { render } from "./studentSelect.vue?vue&type=template&id=49efbda2"
import script from "./studentSelect.vue?vue&type=script&lang=js"
export * from "./studentSelect.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__